import { createSelector } from 'reselect';
import { getVacPageData } from './mainPageData';
import { getAddCompareDtm } from 'src/universal/components/CheckboxCompareButton/redux';
import { getSelectedCompareCards } from 'src/universal/redux/compareCardsTray';
import {
  isProspect as getIsProspect,
  isLoggedOut
} from 'src/universal/redux/userType';

export const addRemoveButtonData = createSelector(
  [getVacPageData, getAddCompareDtm, getSelectedCompareCards],
  (pageData, addCompareDtm, selectedCards) => {
    const { addToCompare = {}, removeFromCompare = {} } = pageData;
    return {
      addToCompare,
      removeFromCompare,
      addCompareDtm,
      selectedCards
    };
  }
);

export const getDynAppHeroContent = createSelector(
  [getVacPageData],
  ({ dynAppVacHero }) => {
    return {
      header: dynAppVacHero?.header || '',
      subHeader: dynAppVacHero?.subHeader || '',
      text: dynAppVacHero?.text || '',
      learnMoreLink: dynAppVacHero?.learnMoreLink || {},
      imageUrl: dynAppVacHero?.imageUrl || ''
    };
  }
);

export const shouldShowDynamicAppVac = createSelector(
  [getIsProspect, isLoggedOut],
  (isProspect, isLoggedOutCM) => {
    return isProspect || isLoggedOutCM;
  }
);

export const getCompareTrayData = createSelector(
  [getVacPageData],
  ({ compareTray }) => {
    return compareTray;
  }
);

export const getApplyByPhoneProps = createSelector([getVacPageData], pageData => ({
  data: pageData?.applyByPhone
}));
